// extracted by mini-css-extract-plugin
export var icon = "_c2-3";
export var subtitle = "_c2-2";
export var title = "_c2-1";
export var value = "_c2-0";